var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aSection"},[_c('div',{staticClass:"aSectionTitle"},[_vm._t("title")],2),_c('div',{staticClass:"aSectionBody"},[_vm._t("body")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }